import { createContext } from 'react';

import type { ActiveConnectedSet } from '../utils/get-active-connected-set.js';

/**
 * The active highlight set — the nodes and links to keep emphasized while every
 * other shape dims — derived once from the store's `hovered`/`selected` identity
 * against the current layout, then shared with every consumer (canvas draw and
 * label overlays). `undefined` means no active highlight (nothing dims).
 *
 * This is derived state, not source state: it is recomputed from the current
 * layout on every render rather than stored, so it never holds references to a
 * stale layout graph after a resize or data change.
 */
export const SankeyHighlightContext = createContext<
  ActiveConnectedSet | undefined
>(undefined);

SankeyHighlightContext['displayName'] = 'SankeyHighlightContext';
